import getUrlParas from './getURLParameter.js'
export function setExposureForCard() {
    try {
        var Exposure = new ExposureClass({
            selector:'.list-model-col .visiblereport-luna-card',
            linkClassName:'list_demo_a',
            platform:'luna',
            multipleExposure:true,
        });
        window.$ExposureForCard = Exposure
    } catch (error) {
        console.log('Exposure error:', error);
    }
}

export function exposureForCardUpdate(){
    if(window.$ExposureForCard){
        window.$ExposureForCard.update && window.$ExposureForCard.update();
    }
}


export function buildExposureInfo(item){
    let urlParam = getUrlParas(),
        param = [];
    Object.keys(urlParam).map(item => {
        if(/^u_/.test(item)){
            param.push(item.replace('u_','') + ':' + urlParam[item])
        }
    })
    let locallist = ____json4fe.locallist ? ____json4fe.locallist : [],
        catentry = ____json4fe.catentry ? ____json4fe.catentry : [],
        localpath = locallist.map((item)=>item.dispid).join(','),
        catepath = catentry.map((item)=>item.dispid).join(',');
    let defaultInfo = {
        // index:index,
        v: 1,
        action: 1001,
        localpath: localpath,
        catepath: catepath,
        keyword: decodeURIComponent(urlParam.kw || ''),
        param: param.join(','),
        referer: document.referrer || '',
        // time: new Date().getTime(),
    };
    const keyArr = ['pos','slot','sid','hugid','creativeShowUrl','lego_tid']
    const extInfo = {}
    keyArr.forEach(e => {
        extInfo[e] = (item.extParamMap && item.extParamMap[e]) || (item.ext && item.ext[e]) || item[e]
    })
    item.ext = item.ext ? item.ext : { showUrl: [] }
    const showUrl = item.ext.showUrl ? item.ext.showUrl : []
    const showUrlStr = showUrl.find(e => e.includes('luna.58.com/track')) || ''
    const showUrlInfo = showUrlStr && showUrlStr.split('?')[0].includes('luna.58.com/track') ? showUrlStr.split('?')[1] : ''
    const showUrlObj = {}
    showUrlInfo.split('&').forEach(e => {
        const arr = e.split('=')
        showUrlObj[arr[0]] = arr[1]
    })
    let info = {
        pn:item._pn || 1,
        ...extInfo,
        infoid:item.infoId,
        adtype:item.adType,
        d: JSON.stringify({ legoid: extInfo['lego_tid'], contextInfo: showUrlObj.contextInfo || '' })
    };
    Object.assign(info,defaultInfo);
    for(let key in info){
        // if(key == 'index') continue;
        info[key] = encodeURIComponent(info[key])
    }
    return JSON.stringify(info)
}